import React from 'react';
import { Page } from '../Page';
import { Droplets, Zap, Award } from 'lucide-react';
export function SupplementElectrolytes() {
  return <Page pageNumber={21} variant="light" data-id="element-2450">
      <div className="flex h-full gap-10" data-id="element-2451">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-2452">
          <img src="https://cdn.magicpatterns.com/uploads/3vpcu2q2uyntMMUQT4U38Z/pasted-image.png" alt="Thorne Daily Electrolytes" className="w-full max-w-[300px] object-contain" data-id="element-2453" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-2454">
          <div className="mb-6 pt-4" data-id="element-2455">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-2456">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-2457">
              Daily Electrolytes
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-2458">
              Replace what GLP-1 side effects deplete
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-2459" />
          </div>

          <div className="mb-6" data-id="element-2460">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-2461">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-2462">
              Dehydration and electrolyte imbalance are among the most common
              GLP-1 side effects. Nausea, vomiting, and reduced fluid intake all
              deplete electrolytes. Zero sugar and only 5 calories, critical
              when every calorie counts.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-2463">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 text-center" data-id="element-2464">
              <p className="text-2xl font-serif text-[#1F1F1F]" data-id="element-2465">480mg</p>
              <p className="text-[10px] text-[#7A7A70] uppercase tracking-wider" data-id="element-2466">
                Sodium
              </p>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 text-center" data-id="element-2467">
              <p className="text-2xl font-serif text-[#1F1F1F]" data-id="element-2468">99mg</p>
              <p className="text-[10px] text-[#7A7A70] uppercase tracking-wider" data-id="element-2469">
                Potassium
              </p>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 text-center" data-id="element-2470">
              <p className="text-2xl font-serif text-[#1F1F1F]" data-id="element-2471">40mg</p>
              <p className="text-[10px] text-[#7A7A70] uppercase tracking-wider" data-id="element-2472">
                Magnesium
              </p>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 text-center" data-id="element-2473">
              <p className="text-2xl font-serif text-[#1F1F1F]" data-id="element-2474">0g</p>
              <p className="text-[10px] text-[#7A7A70] uppercase tracking-wider" data-id="element-2475">
                Sugar
              </p>
            </div>
          </div>

          <div className="mb-6" data-id="element-2476">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-2477">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-2478">
              <li className="flex gap-2" data-id="element-2479">
                <Droplets className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2480" />
                <span data-id="element-2481">
                  Supports energy and reduces fatigue/brain fog from electrolyte
                  depletion
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2482">
                <Zap className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2483" />
                <span data-id="element-2484">
                  Himalayan pink salt, naturally sweetened/flavored, 3 flavors
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2485">
                <Award className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2486" />
                <span data-id="element-2487">Stick packs for on-the-go, NSF Certified for Sport</span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-2488">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-2489">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-2490">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-2491">
                <strong data-id="element-2492">1 stick pack</strong> in at least 12oz water daily
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-2493">
                30 stick packs per bag • 5 calories per serving
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-2494">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-2495" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-2496">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}